import { IOpenNotificationParams } from "@contexts/notification/types";
import { useCallback } from "react";

export const useApiErrorHandler = (
  notify?: (params: IOpenNotificationParams) => void,
  handleErrors?: (errors: any) => void,
) => {
  const errorHandler = useCallback(
    (err: any) => {
      let notification = "";
      let description = "";
      // form validation error
      if (err.statusCode === 400) {
        const {
          response: {
            data: { errors, title, detail },
          },
        } = err;

        if (handleErrors) {
          handleErrors(errors);
        }
        notification = title;
        description = detail;
      } else {
        const {
          response: {
            data: { ErrorMessage, title, detail },
          },
        } = err;

        notification =
          ErrorMessage ||
          title ||
          "Something went wrong. Please contact support.";
        description = detail || "";
      }

      notify?.({
        type: "error",
        message: notification,
        description: description,
      });
    },
    [handleErrors, notify],
  );

  return errorHandler;
};
